if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;



	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"floating-call": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
"defaultVendors-node_modules_crypto-js_enc-hex_js-node_modules_vue-material-design-icons_FileO-a64cc5": 1,
"defaultVendors-node_modules_focus-trap_dist_focus-trap_esm_js-node_modules_vue-material-desig-166a58": 1,
"defaultVendors-node_modules_nextcloud_files_dist_dav_mjs-node_modules_nextcloud_vue_dist_chun-b77a86": 1,
"defaultVendors-node_modules_nextcloud_vue_dist_assets_NcCheckboxRadioSwitch_css-node_modules_-38fbad": 1,
"defaultVendors-node_modules_nextcloud_vue_dist_assets_NcCheckboxRadioSwitch_css-node_modules_-dd10fb": 1,
"defaultVendors-node_modules_nextcloud_vue_dist_components_NcDateTimePicker_index_mjs": 1,
"defaultVendors-node_modules_vue-material-design-icons_AlertOctagonOutline_vue_js_vue_type_scr-df7384": 1,
"defaultVendors-src_components_MessagesList_MessagesGroup_Message_MessagePart_LocationCard_vue": 1,
"node_modules_nextcloud_dialogs_dist_chunks_PublicAuthPrompt_mjs": 1,
"node_modules_nextcloud_vue_dist_assets_NcCheckboxRadioSwitch_css-node_modules_nextcloud_vue_d-16a36a": 1,
"node_modules_nextcloud_vue_dist_assets_NcColorPicker_css-node_modules_nextcloud_vue_dist_comp-fd6456": 1,
"node_modules_nextcloud_vue_dist_assets_NcProfileHoverCard_css": 1,
"src_FloatingCallOverlay_vue": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = extractCssLoadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
// no prefetch
// no preload